module.exports = __webpack_public_path__ + "pn.svg?0886c4f6c31884ba720b1a9d41afb6f9";